import {
    GET_UNAPPROVED_PROMOS,
    UNAPPROVED_PROMO_ERROR,
    ADD_UNAPPROVED_PROMO,
    DELETE_UNAPPROVED_PROMO,
    GET_UNAPPROVED_PROMO,
    UPDATE_UNAPPROVED_PROMO,
    GET_UNAPPROVED_PROMO_DRAFT,
    UNAPPROVED_LOADING,
    REJECT_UNAPPROVED_PROMO
} from "../../actions/types";

const initalizeState = {
    promos: [],
    loading: true,
    error: {},
    remainPromo: true
};

export default function(state = initalizeState, action) {
    const { type, payload } = action;

    switch (type) {
        case UNAPPROVED_LOADING:
            return {
                ...state,
                loading: true
            };
        case GET_UNAPPROVED_PROMOS:
            return {
                ...state,
                promos: payload.unapprovedPromos,
                loading: false
            };
        case ADD_UNAPPROVED_PROMO:
            return {
                ...state,
                promos: [payload.unapprovedPromo, ...state.promos],
                loading: false
            };
        case DELETE_UNAPPROVED_PROMO:
            return {
                ...state,
                promos: state.promos.filter(promo => promo.id !== payload),
                loading: false
            };
        case UPDATE_UNAPPROVED_PROMO:
            let promos = state.promos;
            promos = promos.filter(promo => {
                return promo.id !== payload.id;
            });
            return {
                ...state,
                promos: [...promos],
                loading: false
            };
        case GET_UNAPPROVED_PROMO:
            return {
                ...state,
                loading: false
            };
        case GET_UNAPPROVED_PROMO_DRAFT:
            return {
                ...state,
                loading: false,
                remainPromo: payload.remain
            };
        case REJECT_UNAPPROVED_PROMO:
            return {
                ...state,
                loading: false
            };
        case UNAPPROVED_PROMO_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
